import { useMutation, useQueryClient } from "react-query";
import {
  sendChatMessage,
  deleteConversation,
  updateConversationTitle,
} from "../../../services/aiChat";

export const useSendChatMessage = () => {
  return useMutation((data) => sendChatMessage(data), {
    onSuccess: () => {},
  });
};

// The new title is written into the cached list before the request goes out and
// put back if it fails, so the rename reads as instant.
export const useUpdateConversationTitle = () => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ id, title }) => updateConversationTitle(id, { title }),
    {
      onMutate: async ({ id, title }) => {
        await queryClient.cancelQueries(["aiConversationList"]);
        const previousList = queryClient.getQueryData(["aiConversationList"]);

        queryClient.setQueryData(["aiConversationList"], (list) =>
          (list || []).map((convo) =>
            convo.id === id ? { ...convo, title } : convo,
          ),
        );

        return { previousList };
      },
      onError: (error, variables, context) => {
        if (context?.previousList !== undefined)
          queryClient.setQueryData(
            ["aiConversationList"],
            context.previousList,
          );
      },
    },
  );
};

export const useDeleteConversation = () => {
  const queryClient = useQueryClient();
  return useMutation((id) => deleteConversation(id), {
    onSuccess: () => {
      queryClient.invalidateQueries("aiConversationList");
    },
  });
};
